import Regist from "components/system-management/menu-management/regist";
import _ from "lodash";
import React, { createContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changeCreateAction,
  deleteMenuAction,
  getMenuListAction,
  menuDetailAction,
  menuModifyRequestAction,
  menuRegistRequestAction,
  menuSortAction,
  saveSortAction,
} from "redux/reducers/menu-management/regist";

export const MenuManagementContext = createContext();

export default function MenuManagement() {
  const dispatch = useDispatch();
  const { d1Menu, d2Menu, d3Menu, selectMenu, mode } = useSelector(
    (state) => state.menuManagementRegist
  );

  const submitHandler = (data) => {
    if (mode == "create") {
      dispatch(menuRegistRequestAction(data));
    } else {
      dispatch(menuModifyRequestAction(data));
    }
  };

  const handleSelectCode = (e, cd) => {
    dispatch(menuDetailAction(cd));
  };

  const handleAddMenu = (depth) => {
    dispatch(changeCreateAction(depth));
  };

  const handleDelete = () => {
    dispatch(deleteMenuAction(selectMenu.cd));
  };

  const handleSaveSort = (depth) => {
    let saveList = [];

    _.forEach(depth == "depth2" ? d2Menu : d3Menu, (item) => {
      saveList.push(item.cd);
    });

    dispatch(saveSortAction(saveList));
  };

  const menuSort = (list, depth) => {
    dispatch(menuSortAction({ list, depth }));
  };

  useEffect(() => {
    dispatch(getMenuListAction());
  }, []);

  return (
    <>
      <MenuManagementContext.Provider
        value={{
          d1Menu,
          d2Menu,
          d3Menu,
          selectMenu,
          mode,
          submitHandler,
          handleSelectCode,
          handleAddMenu,
          handleDelete,
          menuSort,
          handleSaveSort,
        }}
      >
        <Regist />
      </MenuManagementContext.Provider>
    </>
  );
}
